export default __webpack_public_path__ + "static/media/logo.2a8c82da.png";